/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CorrectFinplatInstrumentLinkTokenRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/CorrectFinplatInstrumentLinkToken.pb'
import {CorrectFinplatInstrumentLinkTokenResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/CorrectFinplatInstrumentLinkToken.pb'


export const correctFinplatInstrumentLinkToken = (request: CorrectFinplatInstrumentLinkTokenRequest, options?: CashRequestOptions) => post<CorrectFinplatInstrumentLinkTokenRequest, CorrectFinplatInstrumentLinkTokenResponse>("/2.0/cash/correct-finplat-instrument-link-token", request, {...options, rejectOnError: true })